(function () {
    'use strict';

    a3_cabin_reports.factory('PassengerMealServiceFactory', PassengerMealServiceFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name PassengerMealServiceFactory
     * @description 
     *   Add, Update, Delete and Get Passenger meals allergen info.
     * @ngInject
     */
    function PassengerMealServiceFactory(IndexedDBService) {

        /**
         * Initialize MealAllergen
         * @memberof PassengerMealServiceFactory
         */
        function PassengerMealService() {
            this.Id = null;
        }

        var objType = 'PassengerMealServices';
        var objCallback = PassengerMealService;

        var service = {
            setPassengerMealsServicesToStorage: setPassengerMealsServicesToStorage,
            getPassengerMealServicesFromStorage: getPassengerMealServicesFromStorage,
            getPassengerMealServiceFromStorage: getPassengerMealServiceFromStorage,
            checkAndsetPassengerMealsServicesToStorage: checkAndsetPassengerMealsServicesToStorage
        }

        /**
         * Get all passenger meal services
         * @memberof PassengerMealServiceFactory
         * @param {function} callback  
         */
        function getPassengerMealServicesFromStorage(callback) {
            IndexedDBService.getAll(objType).then(function (results) {
                callback(results);
            });
        };
       
        function checkAndsetPassengerMealsServicesToStorage(callback) {
            // Check if callback is null or undefined
            if (!callback || callback.length  === 0) {         
                return; // Exit the function if callback is null
            }

            IndexedDBService.getAll(objType).then(function (results) {
                // Handle cases where results are null or undefined
                if (!results || results.length === 0) {
                    setPassengerMealsServicesToStorage(callback);
                }
                else {
                    // Filter out any undefined or null entries in the results array
                    var validResults = results.filter(service => service && service.CreatedDate);

                    // Check if validResults contains any valid services
                    if (validResults.length > 0) {
                        var storedLatestService = validResults.reduce((latest, current) => {
                            return new Date(latest.CreatedDate) > new Date(current.CreatedDate) ? latest : current;
                        });

                        var firstNewService = callback[0];
                        // Compare the dates
                        var storedCreatedDate = new Date(storedLatestService.CreatedDate);
                        var newCreatedDate = new Date(firstNewService.CreatedDate);

                        if (newCreatedDate > storedCreatedDate) {
                            IndexedDBService.removeAll(objType).then(function () {
                                setPassengerMealsServicesToStorage(callback);
                            });
                        }
                    } else {
                        // If all entries are invalid, remove all entries from IndexedDB
                        IndexedDBService.removeAll(objType).then(function () {
                            setPassengerMealsServicesToStorage(callback);
                        });
                    }
                }
            });
        }
        
        
        function setPassengerMealsServicesToStorage(callback) {
            IndexedDBService.addAll(objType, callback);
        };

          /**
         * Get passenger meal service By Id
         * @memberof PassengerMealServiceFactory
         * @param {function} callback  
         */
          function getPassengerMealServiceFromStorage(serviceId, callback, errorCallback) {
            IndexedDBService.getById(objType, serviceId).then(function(result) {
                callback(result);
            }).catch(errorCallback);
        };
     
        return service;
    }
})();